module.exports = __webpack_public_path__ + "static/media/ATIlogo.e10034ff.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/ATIlogo.png
// module id = 114
// module chunks = 0